import { Component, OnInit, NgZone } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { WindowreffService } from '../services/windowreff.service';
import { ToastrService } from 'ngx-toastr';
import { GlobalVariable } from '../core/global.variable';

@Component({
  selector: 'app-user-wallet',
  templateUrl: './user-wallet.component.html',
  styleUrls: ['./user-wallet.component.css']
})
export class UserWalletComponent implements OnInit {
  loginData: any = localStorage.getItem('token') ? JSON.parse(localStorage.getItem('logindata')) : {}
  balance: any
  walletLogs: any = []
  amount: any = 0
  error: boolean = false
  finalObj: any = {
    customerDetail: {
      name: '',
      phone: '',
      email: ''
    },
    cardDetail: {
      cardNumber: '',
      cardExpDate: '',
      cardCvv: '',

    },
    addressDetail: {
      address: '',
      landmark: '',
      city: '',
      state: '',
      pincode: ''
    }
  }


  constructor(private authSvc: AuthService,
    private ngZone: NgZone,
    private winRef: WindowreffService,
    private toaster: ToastrService) { }

  ngOnInit() {
    this.getWalletBalance()
    this.listWalletLogs()
  }
  getWalletBalance() {
    this.authSvc.walletBalance().subscribe(res => {
      console.log(res)
      this.balance = res["data"][0].wallet
    })
  }
  listWalletLogs() {
    this.authSvc.walletLogs().subscribe(res => {
      this.walletLogs = res["data"]
      console.log(this.walletLogs)
    })
  }
  addAmount() {


    this.authSvc.addWalletAmount(this.amount).subscribe(res => {
      this.ngZone.run(() => {
        this.toaster.success('Money Added to wallet successfully', '', {
          timeOut: 2000
        });
        localStorage.setItem('logindata', JSON.stringify(res["data"]))
        this.loginData = res["data"]

        this.listWalletLogs()
        this.getWalletBalance()
        document.getElementById('amountAddTrigger').click()


      })

    })
  }


  setAmount(value) {
    this.amount = value
  }
  showAddMoney() {
    document.getElementById('amountAddTrigger').click()
  }
  numberOnly(event, id): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }


  }
  payWithRazor() {

    if (this.amount >= 50) {
      this.error = false
      let options: any = {
        "key": GlobalVariable.razor_pay_key,
        "amount": this.amount * 100,
        "name": "Daktarz",
        "description": "Add Money to Wallet",
        //  "image": "./assets/images/logo.png",
        "modal": {
          "escape": false
        },
        "theme": {
          "color": "#26abe3"
        }
      };
      options.handler = ((response) => {
        console.log(response)
        if (response.razorpay_payment_id) {
          //  this.sendBookingData["transaction_id"] = response.razorpay_payment_id
          // this.sendBookingData["plan_id"] = plan._id
          this.addAmount()
        }
        // this.paymentService.payWithRazor({cart: this.finalObj, payment: options});
      });
      options.modal.ondismiss = (() => {
        //  this.loginService.SetLoader = false;
      });
      let rzp = new this.winRef.nativeWindow.Razorpay(options);
      rzp.open();

    }
    else {
      this.error = true
    }


  }

}
